import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {LovValueSummaryFindAllService} from '../../../impl/service/lovValueSummaryFindAll.service';
import {UntypedFormGroup} from '@angular/forms';
import {Subscription} from 'rxjs';
import {SelectElement} from '../../../../../../../components/common/select/select.model';
import {Operator, Order, Sort} from '../../../../../../../shared/utils/url.builder';
import {UrlParameterBuilder} from '../../../../../../core/http/UrlParameterBuilder';

@Component({
  selector: 'app-lov-value-chips-autocomplete',
  templateUrl: './lov-value-chips-autocomplete.component.html',
  providers: [
    LovValueSummaryFindAllService
  ]
})
export class LovValueChipsAutocompleteComponent implements OnChanges, OnDestroy {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() lovListName: string;

  @Input() sort = new Sort('label', Order.ASCENDING);

  subscription: Subscription;
  lovValueElements: SelectElement[] = [];

  constructor(public service: LovValueSummaryFindAllService) {
    this.subscription = this.service.entities$.subscribe(values => {
      this.lovValueElements = values.map(value => new SelectElement(value.value, value.label))
          .sort((a, b) => a.label.localeCompare(b.label));
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['lovListName'] || changes['sort']) {
      this.service.parameters = new UrlParameterBuilder()
          .addParameter('list.name', this.lovListName, Operator.EQUALS)
          .parameters;
      this.service.sort = this.sort;
      this.service.findAll();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
